class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);


// Drawer addons js (Note + Shipping)
// Drawer addons + overlay js

document.body.addEventListener("click", function (event) {

  const overlay = document.querySelector(".m-cart__overlay");

  const closeAllAddons = () => {
    document
      .querySelectorAll(".m-cart-addon__body.open")
      .forEach(el => {
        el.style.height = "0px";
        el.classList.remove("open");
      });

    overlay?.classList.remove("open");
  };

  const openButton = event.target.closest("[data-open]");
  if (openButton) {
    event.preventDefault();

    const addonName = openButton.dataset.open;
    const addonEl = document.getElementById(`m-addons-${addonName}`);

    if (addonEl) {
      closeAllAddons();

      addonEl.classList.add("open");

      const contentHeight = addonEl.scrollHeight;
      addonEl.style.height = contentHeight + "px";

      overlay?.classList.add("open");
    }
    return;
  }

  const closeBtn = event.target.closest(
    ".m-cart-addon--close, .m-cart-addon--save"
  );

  if (closeBtn) {
    event.preventDefault();
    closeAllAddons();
    return;
  }

  if (event.target.closest(".m-cart__overlay")) {
    event.preventDefault();
    closeAllAddons();
  }
});
